import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';

@Component({
  selector: 'eca-app-view-json',
  templateUrl: './view-json.component.html',
  styleUrls: ['./view-json.component.css'],
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose]
})
export class ViewJsonComponent {
  private _dialogRef = inject<MatDialogRef<ViewJsonComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);


  description: string;
  content: string;

  constructor() {
    const data = this.data;

    this.description = data.description;
    this.content = data.content;
  }

}
